export default __webpack_public_path__ + "static/media/1-3-2.bc744cd2.jpg";